/**
 * P4-13: 全局 DialogProvider 宿主与命令式 API。
 *
 * 挂载到一个独立的 React root（#dialogViewport），向 `window.KGNewUI.dialogs`
 * 暴露命令式方法，供旧 index.html 链接与 `game.js` 中不可修改的方法调用。
 */
import { useEffect } from "react";
import { DialogProvider, useDialog } from "../components/Dialog";
import OptionsDialog from "./OptionsDialog";
import ExportDialog from "./ExportDialog";
import ImportDialog from "./ImportDialog";
import CreditsDialog from "./CreditsDialog";
import AppDialog from "./AppDialog";

export interface DialogApi {
  showOptions(): void;
  showExport(): void;
  showImport(): void;
  showCredits(): void;
  showApp(): void;
  closeAll(): void;
}

function DialogRegistry() {
  const { openDialog, closeAllDialogs } = useDialog();

  useEffect(() => {
    const api: DialogApi = {
      showOptions: () =>
        openDialog({ id: "options", title: "Options", children: <OptionsDialog /> }),
      showExport: () =>
        openDialog({ id: "export", title: "Export", children: <ExportDialog /> }),
      showImport: () =>
        openDialog({ id: "import", title: "Import", children: <ImportDialog /> }),
      showCredits: () =>
        openDialog({ id: "credits", title: "Credits", children: <CreditsDialog /> }),
      showApp: () =>
        openDialog({ id: "app", title: "Get the app", children: <AppDialog /> }),
      closeAll: closeAllDialogs,
    };
    (window as { KGNewUI?: { dialogs?: DialogApi } }).KGNewUI = {
      ...(window as { KGNewUI?: Record<string, unknown> }).KGNewUI,
      dialogs: api,
    };
  }, [openDialog, closeAllDialogs]);

  return null;
}

export default function DialogHost() {
  return (
    <DialogProvider>
      <DialogRegistry />
    </DialogProvider>
  );
}
